/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from "@tanstack/react-query";

import { useCallback } from "react";

import type {
    AccessTagsResponse,
    ApiMultipleResult,
    ApiResult,
    AssignPartnerToOrganisationParams,
    CentralSystemResponse,
    CentralSystemsResponse,
    DeleteOrganisationParams,
    DeviceConfigurationSchemaDto,
    DeviceGroupDto,
    GetAccessTagsParams,
    GetDeviceConfigurationSchemaParams,
    GetDeviceTypesParams,
    GetNotificationMethodsParams,
    GetNotificationTypesParams,
    GetRolesAndPermissionsParams,
    InsertOrganisationRequest,
    NotificationMethodDto,
    NotificationTypeDto,
    OrganisationsResponse,
    ProvisionDeviceLookupValues,
    RolesResponse,
    ServiceModelLookupParams,
    UpdateOrganisationRequest,
} from "./query.schemas";

import { useCustomFetchClient } from "./mutator/custom-fetch";
import type { ErrorType, BodyType } from "./mutator/custom-fetch";

/**
 * Lookup the access tags in the system.
 * @deprecated
 */
export const useGetAccessTagsHook = () => {
    const getAccessTags = useCustomFetchClient<AccessTagsResponse>();

    return useCallback(
        (params?: GetAccessTagsParams, signal?: AbortSignal) => {
            return getAccessTags({
                url: `/lookup/access-tags`,
                method: "GET",
                params,
                signal,
            });
        },
        [getAccessTags],
    );
};

export const getGetAccessTagsQueryKey = (params?: GetAccessTagsParams) => {
    return [`/lookup/access-tags`, ...(params ? [params] : [])] as const;
};

export const useGetAccessTagsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetAccessTagsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAccessTagsQueryKey(params);

    const getAccessTags = useGetAccessTagsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>
    > = ({ signal }) => getAccessTags(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccessTagsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>
>;
export type GetAccessTagsQueryError = ErrorType<unknown>;

export function useGetAccessTags<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
    TError = ErrorType<unknown>,
>(
    params: undefined | GetAccessTagsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetAccessTagsHook>>
                    >,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccessTags<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetAccessTagsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetAccessTagsHook>>
                    >,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccessTags<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetAccessTagsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 */

export function useGetAccessTags<
    TData = Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetAccessTagsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetAccessTagsHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetAccessTagsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lookup the organisations and organisation groups in the system.
 */
export const useGetOrganisationsHook = () => {
    const getOrganisations = useCustomFetchClient<OrganisationsResponse>();

    return useCallback(
        (signal?: AbortSignal) => {
            return getOrganisations({
                url: `/lookup/organisations`,
                method: "GET",
                signal,
            });
        },
        [getOrganisations],
    );
};

export const getGetOrganisationsQueryKey = () => {
    return [`/lookup/organisations`] as const;
};

export const useGetOrganisationsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetOrganisationsQueryKey();

    const getOrganisations = useGetOrganisationsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>
    > = ({ signal }) => getOrganisations(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganisationsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>
>;
export type GetOrganisationsQueryError = ErrorType<unknown>;

export function useGetOrganisations<
    TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetOrganisationsHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetOrganisationsHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganisations<
    TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetOrganisationsHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetOrganisationsHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganisations<
    TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrganisations<
    TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetOrganisationsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create a new Organisation.
 */
export const useCreateOrganisationHook = () => {
    const createOrganisation = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            insertOrganisationRequest?: BodyType<InsertOrganisationRequest>,
            signal?: AbortSignal,
        ) => {
            return createOrganisation({
                url: `/lookup/organisations`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: insertOrganisationRequest,
                signal,
            });
        },
        [createOrganisation],
    );
};

export const useCreateOrganisationMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>,
        TError,
        { data?: BodyType<InsertOrganisationRequest> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>,
    TError,
    { data?: BodyType<InsertOrganisationRequest> },
    TContext
> => {
    const mutationKey = ["createOrganisation"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const createOrganisation = useCreateOrganisationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>,
        { data?: BodyType<InsertOrganisationRequest> }
    > = (props) => {
        const { data } = props ?? {};

        return createOrganisation(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateOrganisationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>
>;
export type CreateOrganisationMutationBody =
    | BodyType<InsertOrganisationRequest>
    | undefined;
export type CreateOrganisationMutationError = ErrorType<unknown>;

export const useCreateOrganisation = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>,
            TError,
            { data?: BodyType<InsertOrganisationRequest> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>,
    TError,
    { data?: BodyType<InsertOrganisationRequest> },
    TContext
> => {
    return useMutation(
        useCreateOrganisationMutationOptions(options),
        queryClient,
    );
};
/**
 * Delete an Organisation. Org must have no device groups, user accounts, or rfid tags assigned before it can be deleted.
 */
export const useDeleteOrganisationHook = () => {
    const deleteOrganisation = useCustomFetchClient<ApiMultipleResult>();

    return useCallback(
        (params: DeleteOrganisationParams, signal?: AbortSignal) => {
            return deleteOrganisation({
                url: `/lookup/organisations`,
                method: "DELETE",
                params,
                signal,
            });
        },
        [deleteOrganisation],
    );
};

export const useDeleteOrganisationMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationHook>>>,
        TError,
        { params: DeleteOrganisationParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationHook>>>,
    TError,
    { params: DeleteOrganisationParams },
    TContext
> => {
    const mutationKey = ["deleteOrganisation"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const deleteOrganisation = useDeleteOrganisationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationHook>>>,
        { params: DeleteOrganisationParams }
    > = (props) => {
        const { params } = props ?? {};

        return deleteOrganisation(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteOrganisationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationHook>>>
>;

export type DeleteOrganisationMutationError = ErrorType<unknown>;

export const useDeleteOrganisation = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationHook>>>,
            TError,
            { params: DeleteOrganisationParams },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationHook>>>,
    TError,
    { params: DeleteOrganisationParams },
    TContext
> => {
    return useMutation(
        useDeleteOrganisationMutationOptions(options),
        queryClient,
    );
};
/**
 * Lookup the device types in the system.
 */
export const useGetDeviceTypesHook = () => {
    const getDeviceTypes = useCustomFetchClient<string[]>();

    return useCallback(
        (params?: GetDeviceTypesParams, signal?: AbortSignal) => {
            return getDeviceTypes({
                url: `/lookup/device-types`,
                method: "GET",
                params,
                signal,
            });
        },
        [getDeviceTypes],
    );
};

export const getGetDeviceTypesQueryKey = (params?: GetDeviceTypesParams) => {
    return [`/lookup/device-types`, ...(params ? [params] : [])] as const;
};

export const useGetDeviceTypesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetDeviceTypesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetDeviceTypesQueryKey(params);

    const getDeviceTypes = useGetDeviceTypesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>
    > = ({ signal }) => getDeviceTypes(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeviceTypesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>
>;
export type GetDeviceTypesQueryError = ErrorType<unknown>;

export function useGetDeviceTypes<
    TData = Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params: undefined | GetDeviceTypesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetDeviceTypesHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetDeviceTypesHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeviceTypes<
    TData = Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetDeviceTypesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetDeviceTypesHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetDeviceTypesHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeviceTypes<
    TData = Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetDeviceTypesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDeviceTypes<
    TData = Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetDeviceTypesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetDeviceTypesHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetDeviceTypesQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lookup the roles and permissions in the system.
 */
export const useGetRolesAndPermissionsHook = () => {
    const getRolesAndPermissions = useCustomFetchClient<RolesResponse>();

    return useCallback(
        (params?: GetRolesAndPermissionsParams, signal?: AbortSignal) => {
            return getRolesAndPermissions({
                url: `/lookup/roles-permissions`,
                method: "GET",
                params,
                signal,
            });
        },
        [getRolesAndPermissions],
    );
};

export const getGetRolesAndPermissionsQueryKey = (
    params?: GetRolesAndPermissionsParams,
) => {
    return [`/lookup/roles-permissions`, ...(params ? [params] : [])] as const;
};

export const useGetRolesAndPermissionsQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetRolesAndPermissionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetRolesAndPermissionsQueryKey(params);

    const getRolesAndPermissions = useGetRolesAndPermissionsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>>
    > = ({ signal }) => getRolesAndPermissions(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRolesAndPermissionsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>>
>;
export type GetRolesAndPermissionsQueryError = ErrorType<unknown>;

export function useGetRolesAndPermissions<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params: undefined | GetRolesAndPermissionsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetRolesAndPermissionsHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetRolesAndPermissionsHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRolesAndPermissions<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetRolesAndPermissionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetRolesAndPermissionsHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetRolesAndPermissionsHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRolesAndPermissions<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetRolesAndPermissionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRolesAndPermissions<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetRolesAndPermissionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetRolesAndPermissionsHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetRolesAndPermissionsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lookup available device configuration keys and data types for the entire system, or filtered for a DeviceType or model
 */
export const useGetDeviceConfigurationSchemaHook = () => {
    const getDeviceConfigurationSchema =
        useCustomFetchClient<DeviceConfigurationSchemaDto[]>();

    return useCallback(
        (params?: GetDeviceConfigurationSchemaParams, signal?: AbortSignal) => {
            return getDeviceConfigurationSchema({
                url: `/lookup/device-configuration-schema`,
                method: "GET",
                params,
                signal,
            });
        },
        [getDeviceConfigurationSchema],
    );
};

export const getGetDeviceConfigurationSchemaQueryKey = (
    params?: GetDeviceConfigurationSchemaParams,
) => {
    return [
        `/lookup/device-configuration-schema`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetDeviceConfigurationSchemaQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDeviceConfigurationSchemaHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetDeviceConfigurationSchemaParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetDeviceConfigurationSchemaHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetDeviceConfigurationSchemaQueryKey(params);

    const getDeviceConfigurationSchema = useGetDeviceConfigurationSchemaHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetDeviceConfigurationSchemaHook>>
        >
    > = ({ signal }) => getDeviceConfigurationSchema(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetDeviceConfigurationSchemaHook>>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeviceConfigurationSchemaQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetDeviceConfigurationSchemaHook>>>
>;
export type GetDeviceConfigurationSchemaQueryError = ErrorType<unknown>;

export function useGetDeviceConfigurationSchema<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDeviceConfigurationSchemaHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params: undefined | GetDeviceConfigurationSchemaParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetDeviceConfigurationSchemaHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetDeviceConfigurationSchemaHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetDeviceConfigurationSchemaHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeviceConfigurationSchema<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDeviceConfigurationSchemaHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetDeviceConfigurationSchemaParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetDeviceConfigurationSchemaHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetDeviceConfigurationSchemaHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetDeviceConfigurationSchemaHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeviceConfigurationSchema<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDeviceConfigurationSchemaHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetDeviceConfigurationSchemaParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetDeviceConfigurationSchemaHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDeviceConfigurationSchema<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetDeviceConfigurationSchemaHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetDeviceConfigurationSchemaParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetDeviceConfigurationSchemaHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetDeviceConfigurationSchemaQueryOptions(
        params,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lookup fields for ProvisionDevice endpoint. Includes values for DeviceType and Model
 */
export const useGetProvisionDeviceLookupValuesHook = () => {
    const getProvisionDeviceLookupValues =
        useCustomFetchClient<ProvisionDeviceLookupValues>();

    return useCallback(
        (signal?: AbortSignal) => {
            return getProvisionDeviceLookupValues({
                url: `/lookup/provision-device-values`,
                method: "GET",
                signal,
            });
        },
        [getProvisionDeviceLookupValues],
    );
};

export const getGetProvisionDeviceLookupValuesQueryKey = () => {
    return [`/lookup/provision-device-values`] as const;
};

export const useGetProvisionDeviceLookupValuesQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetProvisionDeviceLookupValuesHook>>
    >,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetProvisionDeviceLookupValuesHook>
                >
            >,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetProvisionDeviceLookupValuesQueryKey();

    const getProvisionDeviceLookupValues =
        useGetProvisionDeviceLookupValuesHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetProvisionDeviceLookupValuesHook>>
        >
    > = ({ signal }) => getProvisionDeviceLookupValues(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetProvisionDeviceLookupValuesHook>>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProvisionDeviceLookupValuesQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useGetProvisionDeviceLookupValuesHook>>
    >
>;
export type GetProvisionDeviceLookupValuesQueryError = ErrorType<unknown>;

export function useGetProvisionDeviceLookupValues<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetProvisionDeviceLookupValuesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetProvisionDeviceLookupValuesHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetProvisionDeviceLookupValuesHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetProvisionDeviceLookupValuesHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProvisionDeviceLookupValues<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetProvisionDeviceLookupValuesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetProvisionDeviceLookupValuesHook>
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetProvisionDeviceLookupValuesHook
                            >
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<
                                typeof useGetProvisionDeviceLookupValuesHook
                            >
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProvisionDeviceLookupValues<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetProvisionDeviceLookupValuesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetProvisionDeviceLookupValuesHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetProvisionDeviceLookupValues<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetProvisionDeviceLookupValuesHook>>
    >,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<typeof useGetProvisionDeviceLookupValuesHook>
                    >
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetProvisionDeviceLookupValuesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lookup the third party central systems in the system.
 */
export const useGetCentralSystemsHook = () => {
    const getCentralSystems = useCustomFetchClient<CentralSystemsResponse>();

    return useCallback(
        (signal?: AbortSignal) => {
            return getCentralSystems({
                url: `/lookup/central-systems`,
                method: "GET",
                signal,
            });
        },
        [getCentralSystems],
    );
};

export const getGetCentralSystemsQueryKey = () => {
    return [`/lookup/central-systems`] as const;
};

export const useGetCentralSystemsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCentralSystemsQueryKey();

    const getCentralSystems = useGetCentralSystemsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>
    > = ({ signal }) => getCentralSystems(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCentralSystemsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>
>;
export type GetCentralSystemsQueryError = ErrorType<unknown>;

export function useGetCentralSystems<
    TData = Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetCentralSystemsHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetCentralSystemsHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetCentralSystemsHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCentralSystems<
    TData = Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetCentralSystemsHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetCentralSystemsHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetCentralSystemsHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCentralSystems<
    TData = Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetCentralSystemsHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCentralSystems<
    TData = Awaited<ReturnType<ReturnType<typeof useGetCentralSystemsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetCentralSystemsHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetCentralSystemsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Insert a new Central System.
 */
export const useCentralSystemInsertHook = () => {
    const centralSystemInsert = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            centralSystemResponse?: BodyType<CentralSystemResponse>,
            signal?: AbortSignal,
        ) => {
            return centralSystemInsert({
                url: `/lookup/central-systems`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: centralSystemResponse,
                signal,
            });
        },
        [centralSystemInsert],
    );
};

export const useCentralSystemInsertMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCentralSystemInsertHook>>>,
        TError,
        { data?: BodyType<CentralSystemResponse> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCentralSystemInsertHook>>>,
    TError,
    { data?: BodyType<CentralSystemResponse> },
    TContext
> => {
    const mutationKey = ["centralSystemInsert"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const centralSystemInsert = useCentralSystemInsertHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCentralSystemInsertHook>>>,
        { data?: BodyType<CentralSystemResponse> }
    > = (props) => {
        const { data } = props ?? {};

        return centralSystemInsert(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CentralSystemInsertMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCentralSystemInsertHook>>>
>;
export type CentralSystemInsertMutationBody =
    | BodyType<CentralSystemResponse>
    | undefined;
export type CentralSystemInsertMutationError = ErrorType<unknown>;

export const useCentralSystemInsert = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCentralSystemInsertHook>>>,
            TError,
            { data?: BodyType<CentralSystemResponse> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCentralSystemInsertHook>>>,
    TError,
    { data?: BodyType<CentralSystemResponse> },
    TContext
> => {
    return useMutation(
        useCentralSystemInsertMutationOptions(options),
        queryClient,
    );
};
/**
 * Edit an Organisation, an org's full name can be edited.
 */
export const useUpdateOrganisationHook = () => {
    const updateOrganisation = useCustomFetchClient<ApiResult>();

    return useCallback(
        (
            updateOrganisationRequest?: BodyType<UpdateOrganisationRequest>,
            signal?: AbortSignal,
        ) => {
            return updateOrganisation({
                url: `/lookup/organisations/update`,
                method: "POST",
                headers: { "Content-Type": "application/json" },
                data: updateOrganisationRequest,
                signal,
            });
        },
        [updateOrganisation],
    );
};

export const useUpdateOrganisationMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>,
        TError,
        { data?: BodyType<UpdateOrganisationRequest> },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>,
    TError,
    { data?: BodyType<UpdateOrganisationRequest> },
    TContext
> => {
    const mutationKey = ["updateOrganisation"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const updateOrganisation = useUpdateOrganisationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>,
        { data?: BodyType<UpdateOrganisationRequest> }
    > = (props) => {
        const { data } = props ?? {};

        return updateOrganisation(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateOrganisationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>
>;
export type UpdateOrganisationMutationBody =
    | BodyType<UpdateOrganisationRequest>
    | undefined;
export type UpdateOrganisationMutationError = ErrorType<unknown>;

export const useUpdateOrganisation = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>,
            TError,
            { data?: BodyType<UpdateOrganisationRequest> },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>,
    TError,
    { data?: BodyType<UpdateOrganisationRequest> },
    TContext
> => {
    return useMutation(
        useUpdateOrganisationMutationOptions(options),
        queryClient,
    );
};
/**
 * Lookup the notification types in the system.
 */
export const useGetNotificationTypesHook = () => {
    const getNotificationTypes = useCustomFetchClient<NotificationTypeDto[]>();

    return useCallback(
        (params?: GetNotificationTypesParams, signal?: AbortSignal) => {
            return getNotificationTypes({
                url: `/lookup/notification-types`,
                method: "GET",
                params,
                signal,
            });
        },
        [getNotificationTypes],
    );
};

export const getGetNotificationTypesQueryKey = (
    params?: GetNotificationTypesParams,
) => {
    return [`/lookup/notification-types`, ...(params ? [params] : [])] as const;
};

export const useGetNotificationTypesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetNotificationTypesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationTypesHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetNotificationTypesQueryKey(params);

    const getNotificationTypes = useGetNotificationTypesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetNotificationTypesHook>>>
    > = ({ signal }) => getNotificationTypes(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetNotificationTypesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationTypesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetNotificationTypesHook>>>
>;
export type GetNotificationTypesQueryError = ErrorType<unknown>;

export function useGetNotificationTypes<
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params: undefined | GetNotificationTypesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationTypesHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetNotificationTypesHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetNotificationTypesHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationTypes<
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetNotificationTypesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationTypesHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetNotificationTypesHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetNotificationTypesHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationTypes<
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetNotificationTypesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationTypesHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetNotificationTypes<
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationTypesHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: GetNotificationTypesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationTypesHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetNotificationTypesQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lookup the notification methods in the system.
 */
export const useGetNotificationMethodsHook = () => {
    const getNotificationMethods =
        useCustomFetchClient<NotificationMethodDto[]>();

    return useCallback(
        (params?: GetNotificationMethodsParams, signal?: AbortSignal) => {
            return getNotificationMethods({
                url: `/lookup/notification-methods`,
                method: "GET",
                params,
                signal,
            });
        },
        [getNotificationMethods],
    );
};

export const getGetNotificationMethodsQueryKey = (
    params?: GetNotificationMethodsParams,
) => {
    return [
        `/lookup/notification-methods`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetNotificationMethodsQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetNotificationMethodsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetNotificationMethodsQueryKey(params);

    const getNotificationMethods = useGetNotificationMethodsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>>
    > = ({ signal }) => getNotificationMethods(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationMethodsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>>
>;
export type GetNotificationMethodsQueryError = ErrorType<unknown>;

export function useGetNotificationMethods<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params: undefined | GetNotificationMethodsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetNotificationMethodsHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetNotificationMethodsHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationMethods<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetNotificationMethodsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetNotificationMethodsHook>
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            ReturnType<typeof useGetNotificationMethodsHook>
                        >
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationMethods<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetNotificationMethodsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetNotificationMethods<
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
    >,
    TError = ErrorType<unknown>,
>(
    params?: GetNotificationMethodsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useGetNotificationMethodsHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetNotificationMethodsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Unlike DeviceGroupsOData, which will only return device groups in your org, this method returns all ServiceModel groups that you have devices in. Optionally supply a deviceIdentity to return only the service model for that device.
 */
export const useServiceModelLookupHook = () => {
    const serviceModelLookup = useCustomFetchClient<DeviceGroupDto[]>();

    return useCallback(
        (params?: ServiceModelLookupParams, signal?: AbortSignal) => {
            return serviceModelLookup({
                url: `/lookup/service-models`,
                method: "GET",
                params,
                signal,
            });
        },
        [serviceModelLookup],
    );
};

export const getServiceModelLookupQueryKey = (
    params?: ServiceModelLookupParams,
) => {
    return [`/lookup/service-models`, ...(params ? [params] : [])] as const;
};

export const useServiceModelLookupQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useServiceModelLookupHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: ServiceModelLookupParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                >,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getServiceModelLookupQueryKey(params);

    const serviceModelLookup = useServiceModelLookupHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useServiceModelLookupHook>>>
    > = ({ signal }) => serviceModelLookup(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useServiceModelLookupHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ServiceModelLookupQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useServiceModelLookupHook>>>
>;
export type ServiceModelLookupQueryError = ErrorType<unknown>;

export function useServiceModelLookup<
    TData = Awaited<ReturnType<ReturnType<typeof useServiceModelLookupHook>>>,
    TError = ErrorType<unknown>,
>(
    params: undefined | ServiceModelLookupParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useServiceModelLookup<
    TData = Awaited<ReturnType<ReturnType<typeof useServiceModelLookupHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: ServiceModelLookupParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useServiceModelLookup<
    TData = Awaited<ReturnType<ReturnType<typeof useServiceModelLookupHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: ServiceModelLookupParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useServiceModelLookup<
    TData = Awaited<ReturnType<ReturnType<typeof useServiceModelLookupHook>>>,
    TError = ErrorType<unknown>,
>(
    params?: ServiceModelLookupParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<ReturnType<typeof useServiceModelLookupHook>>
                >,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useServiceModelLookupQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lookup the available contractors for scheduled maintenance.
 */
export const useGetContractorsHook = () => {
    const getContractors = useCustomFetchClient<string[]>();

    return useCallback(
        (signal?: AbortSignal) => {
            return getContractors({
                url: `/lookup/contractors`,
                method: "GET",
                signal,
            });
        },
        [getContractors],
    );
};

export const getGetContractorsQueryKey = () => {
    return [`/lookup/contractors`] as const;
};

export const useGetContractorsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetContractorsQueryKey();

    const getContractors = useGetContractorsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>
    > = ({ signal }) => getContractors(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContractorsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>
>;
export type GetContractorsQueryError = ErrorType<unknown>;

export function useGetContractors<
    TData = Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetContractorsHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetContractorsHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContractors<
    TData = Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetContractorsHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetContractorsHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContractors<
    TData = Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContractors<
    TData = Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetContractorsHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetContractorsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Assign/clear an organisation's parent (partner).
 */
export const useAssignPartnerToOrganisationHook = () => {
    const assignPartnerToOrganisation =
        useCustomFetchClient<ApiMultipleResult>();

    return useCallback(
        (
            targetOrganisationId: string,
            params?: AssignPartnerToOrganisationParams,
            signal?: AbortSignal,
        ) => {
            return assignPartnerToOrganisation({
                url: `/lookup/organisations/${targetOrganisationId}/partner`,
                method: "PUT",
                params,
                signal,
            });
        },
        [assignPartnerToOrganisation],
    );
};

export const useAssignPartnerToOrganisationMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof useAssignPartnerToOrganisationHook>>
        >,
        TError,
        {
            targetOrganisationId: string;
            params?: AssignPartnerToOrganisationParams;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignPartnerToOrganisationHook>>>,
    TError,
    {
        targetOrganisationId: string;
        params?: AssignPartnerToOrganisationParams;
    },
    TContext
> => {
    const mutationKey = ["assignPartnerToOrganisation"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const assignPartnerToOrganisation = useAssignPartnerToOrganisationHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof useAssignPartnerToOrganisationHook>>
        >,
        {
            targetOrganisationId: string;
            params?: AssignPartnerToOrganisationParams;
        }
    > = (props) => {
        const { targetOrganisationId, params } = props ?? {};

        return assignPartnerToOrganisation(targetOrganisationId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type AssignPartnerToOrganisationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAssignPartnerToOrganisationHook>>>
>;

export type AssignPartnerToOrganisationMutationError = ErrorType<unknown>;

export const useAssignPartnerToOrganisation = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useAssignPartnerToOrganisationHook>
                >
            >,
            TError,
            {
                targetOrganisationId: string;
                params?: AssignPartnerToOrganisationParams;
            },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAssignPartnerToOrganisationHook>>>,
    TError,
    {
        targetOrganisationId: string;
        params?: AssignPartnerToOrganisationParams;
    },
    TContext
> => {
    return useMutation(
        useAssignPartnerToOrganisationMutationOptions(options),
        queryClient,
    );
};
